import type { TeamId } from '@suntex.fim/api-client';
import { EntityLevel } from '@suntex.fim/enums';
import { TeamProvider } from '@suntex.fim/team';

import {
  type EntityLayoutProps,
  createEntityLayout,
} from './createEntityLayout';

export type TeamLayoutProps = EntityLayoutProps;

/** Layout wrapper for team-scoped routes (`/team/:teamId/...`). */
export const TeamLayout = createEntityLayout<TeamId>({
  entityLevel: EntityLevel.Team,
  paramName: 'teamId',
  renderProvider: (id, children) => (
    <TeamProvider teamId={id}>{children}</TeamProvider>
  ),
});
